// extracted by mini-css-extract-plugin
export default {"ArrowButton":"PopupFooterV2__ArrowButton___2gGsv","EllipsisMenu":"PopupFooterV2__EllipsisMenu___h42tg"};